import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getExportStatus = async (jobId) => {
  return await fetchData(`${API_CONSTANTS.EXPORT}/status/${jobId}`, {});
};
